/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';

import { Channel } from '../../../core/entities/Channel';
import { GuideType } from '../../../core/enums';
import {
    RESET_CATEGORIES_FILTER,
    SET_CHANNEL_OPTIONS,
    SET_CHANNEL_OPTIONS_OVERLAY_CONTEXT,
    SET_CHANNELS_TYPE,
} from './channeloptionsoverlay.types';
import { TChannelV2 } from '../../../core/types';

export const setChannelsTypeAction = (
    channelsType: string,
    categoriesType: string,
    channelsTypeIndex: string,
    categoriesTypeIndex: string,
): AnyAction => ({
    type: SET_CHANNELS_TYPE,
    payload: {
        channelsType,
        categoriesType,
        channelsTypeIndex,
        categoriesTypeIndex,
    },
});

export const setChannelOptionsAction = (
    channelsType: string,
    categoriesType: string,
    watchNowText: string,
    channelsText: string,
    categoriesText: string,
    horizontalSelectionOptions: string[],
    horizontalCategoriesSelectionOptions: string[],
): AnyAction => ({
    type: SET_CHANNEL_OPTIONS,
    payload: {
        channelsType,
        watchNowText,
        channelsText,
        horizontalSelectionOptions,
        categoriesType,
        categoriesText,
        horizontalCategoriesSelectionOptions,
    },
});

export const setChannelOptionsOverlayContextAction = (
    channel: Channel | TChannelV2,
    guideType: GuideType,
): AnyAction => ({
    type: SET_CHANNEL_OPTIONS_OVERLAY_CONTEXT,
    payload: {
        channel,
        guideType,
    },
});

export const resetCategoriesFilterAction = (): AnyAction => ({
    type: RESET_CATEGORIES_FILTER,
});
